import { useI18n } from '@core/plugins/plugin-i18n'
import { captureException } from '@sentry/vue'
import { isAxiosError } from 'axios'
import { toast } from 'vue-sonner'

export function useServerErrorHandler() {
  const { t } = useI18n()

  function onError(error: any, hideToast: boolean = false): string {
    let detail = t('base.unknown_error')
    if (
      isAxiosError(error)
      && error.response?.data?.message
    ) {
      if (typeof error?.response?.data?.message === 'string') {
        detail = error?.response?.data?.message
      }
      else {
        let messages: string[] = []
        for (const [, value] of Object.entries(error?.response?.data?.message)) {
          messages = [...messages, ...value as string]
        }
        if (messages.length > 0) {
          detail = messages.join('\n')
        }
      }
    }

    if (detail === t('base.unknown_error') && isAxiosError(error) && error.response?.status) {
      detail = t(`base.${error.response?.status}`)
    }

    if (!hideToast) {
      toast.error(detail, {
        duration: 3000,
      })
    }
    captureException(error, (scope) => {
      return scope
    })
    return detail
  }

  return {
    onError,
  }
}
